import { createFileRoute } from "@tanstack/react-router";

import { SettingsAccountPayments } from "@/features/my/settings/account/billing/payments";

export const Route = createFileRoute(
  "/(member)/(protected)/my/settings/account/billing/payments/",
)({
  component: SettingsAccountPayments,
});
